import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserMyCollections = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M23 23H6V6h17zM9 20h11V9H9zm33 3H25V6h17zm-14-3h11V9H28zm-5 22H6V25h17zM9 39h11V28H9zm33 3H25V25h17zm-14-3h11V28H28z" })
});
export default SvgUserMyCollections;
